function userHasPerm(sessionData, permID) {
    if(sessionData.permissions[permID] != null){
        console.log("Has Perm " + permID);
        return true;
    }
    console.log("Does not have perm " + permID)
    return false;
}

export default { userHasPerm };